import React from 'react';
import getImage from './getImage';
import ImageBlock from '../components/ImageBlock';
import TextBlock from '../components/TextBlock';
import Sidenote from '../components/Sidenote';
import VideoBlock from '../components/VideoBlock';
import Carousel from '../components/Carousel';
import ChapterReflection from '../containers/ChapterReflectionContainer';

function renderSectionContent(element, index, elements, chapterData) {
  switch (element.acf_fc_layout) {
    case 'textblock':
      return <TextBlock key={index} content={element.text} />;
    case 'block_image':
      return (
        <ImageBlock
          textwidth={element.textwidth}
          key={index}
          index={elements.reduce((p, c, i, ems) => {
            if (i > index || ems[i].acf_fc_layout !== 'block_image') return p;
            return p + 1;
          }, 0)}
          src={getImage(element.image.sizes, window.innerWidth)}
          alt={element.image.alt}
          imageText={element.image.caption}
        />
      );
    case 'video':
      return (
        <VideoBlock
          textwidth={element.textwidth}
          key={index}
          video={element.video}
        />
      );
    case 'carousel':
      return <Carousel key={index} slides={element.slides} />;
    case 'blockquote':
      return null;
    case 'externalLink':
      return (
        <Sidenote
          key={index}
          title="Les også"
          action={element.link}
          actionLabel={element.linkLabel}
          icon={element.icon}
          link
        >
          {element.text}
        </Sidenote>
      );
    case 'factbox':
      return (
        <Sidenote
          key={index}
          title={element.title ? element.title : null}
          factBox
          icon={element.icon}
          num={element.title === 'Vår visjon'}
        >
          {element.text}
        </Sidenote>
      );
    case 'sheet':
      return (
        <Sidenote
          key={index}
          title="Materiell"
          action={element.file.url}
          actionLabel={element.file.caption}
          icon={element.icon}
          sheet
        >
          {element.text}
        </Sidenote>
      );
    case 'reflections':
      return (
        <ChapterReflection
          chapterId={chapterData.chapter}
          part={chapterData.part}
          reflectionID={parseInt(element.id, 10)}
          reflections={element.reflection}
        />
      );
    default:
      return null;
  }
}

export default renderSectionContent;



// WEBPACK FOOTER //
// ./src/utils/renderSectionContent.js